import React from 'react';

export default function Footer(props) {
    return(
        <footer className="remote-edge">Built by Steven Wagner. Movie data from <a href="OMDB.com" target="_blank">omdbapi.com</a>. 2019</footer>
    )
}